export default __webpack_public_path__ + "static/media/KanoMarvelDevResume202102fortheWeb.bcca93fc.pdf";